import type { Policy } from '$lib/types/policies';
import { EMAIL_SUBJECT, EMAIL_TO } from './text';

export const POLICIES: Policy[] = [
  {
    name: 'Cookie Policy',
    path: '/cookie-policy',
    enabled: true,
    rank: 2
  },
  {
    name: 'Terms of Service',
    path: '/terms-of-service',
    enabled: true,
    rank: 3
  },
  {
    name: 'User Feedback',
    path: `mailto:${EMAIL_TO}?subject=${EMAIL_SUBJECT}`,
    enabled: true,
    rank: 5
  },
  {
    name: 'User Survey',
    path: 'https://z44yutovxe7.typeform.com/to/LUBEFRTN',
    enabled: true,
    rank: 1
  },
  {
    name: 'About MySites',
    path: '/FAQ',
    enabled: true,
    rank: 0
  }
  // {
  //   name: 'Privacy Policy',
  //   path: 'https://www.swishapps.ai/legal/privacy',
  //   enabled: true,
  //   rank: 5
  // }
];
